import React, { Fragment, PureComponent } from 'react'
import Immutable from 'immutable'

import { noImg } from '@libs/postTools'
import appUrl, { imageUrl, openPost } from '@libs/appUrl'

import { InView } from 'react-intersection-observer'

import { withTranslation } from '@hocs'
import { trackWebHomePageArticleListEnterArticleEvent } from '@libs/eventTracking/homePage/web-homepage.article-list.enter-article'
import qs from 'qs'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import ArticleCard from '@components/ArticleCard'
import ClampLines from '@components/ClampLines'

import cx from 'classnames'
import styles from './PcCarousel.scss'

class PcCarousel extends PureComponent {
  static defaultProps = {
    className: '',
    isLoading: true,
    carouselSlider: Immutable.fromJS([]),
    carouselPost: Immutable.fromJS(new Array(5)),
  }

  constructor(props) {
    super(props)
    this.covers = []
    this.bgc = noImg
    this.sliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      lazyLoad: 'progressive',
      autoplay: true,
      autoplaySpeed: 2000,
    }
  }

  handlePopdailyArticleClick = (postID, index, clas) => (e) => {
    if (e) e.stopPropagation()
    if (index === 4) {
      openPost(`${appUrl.myhost}/${clas}?titlebar=1`)
      return
    }

    const postUrl = `${appUrl.myhost}/${postID.replace(/\./g, '/')}`
    const trackQueryString = qs.stringify({
      ...qs.parse(postUrl.split('?')[1]),
      fromPage: {
        pageName: 'web-homepage',
        pageComponent: 'article-list',
      },
    })
    trackWebHomePageArticleListEnterArticleEvent({
      currentPage: {
        pageName: 'web-homepage',
      },
      toPage: {
        pageUrl: postUrl,
      },
      actionTarget: postID,
    })
    openPost(`${postUrl}?${trackQueryString}`)
  }

  lazyloadBGImg = (inview) => {
    if (inview) {
      this.covers.forEach((cover) => {
        if (!cover.style.backgroundImage) {
          cover.style.backgroundImage = `url('${cover.dataset.src}')`
        }
      })
    }
  }

  render() {
    const { className, isLoading, t } = this.props
    const carouselPost = this.props.carouselPost.toJS()
    const carouselSlider = this.props.carouselSlider.toJS()
    const classNames = cx('PcCarousel', className, { isLoading })
    const getBgImg = (img) => (img ? imageUrl(img.path) : this.bgc)
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <div className={classNames}>
          <div className="grid">
            <div className="slider">
              {carouselSlider.length === 0 ? null : (
                <Slider {...this.sliderSettings}>
                  {carouselSlider.map((article) => (
                    <ArticleCard
                      className="PcCarousel"
                      key={`carouselSlider-${article.postID}`}
                      article={article}
                    />
                  ))}
                </Slider>
              )}
            </div>
            {carouselPost.map((article = {}, index) => {
              const { postID, clas, img = [], title, text, web } = article
              const coverImg = getBgImg(img[0])
              return !postID ? (
                <article key={index} className="card" />
              ) : (
                <article
                  key={`carouselPost-${postID}`}
                  className="card"
                  onClick={this.handlePopdailyArticleClick(postID, index, clas)}
                  data-more={t('common:SeeMorePopDailyArticle')}
                >
                  <div
                    ref={(cover) => (this.covers[index] = this.covers[index] || cover)}
                    className="cover"
                    data-src={coverImg}
                  >
                    <InView
                      threshold={0.01}
                      as="div"
                      className="cover"
                      onChange={this.lazyloadBGImg}
                    />
                  </div>
                  <div className="info">
                    <ClampLines
                      tag="h3"
                      className="carouselPost-title"
                      lines={2}
                      text={(title || text).substr(0, 100)}
                    />
                    <ClampLines
                      tag="h4"
                      className="carouselPost-desc"
                      lines={2}
                      text={((web ? web.text : text) || '').substr(0, 100)}
                    />
                  </div>
                </article>
              )
            })}
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withTranslation()(PcCarousel)
